import type { CMSFacilityType } from '@/cms/fields/mappers/productDetailPageFieldsMapper'
import { space, tok, tokPx } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

interface FacilityTypeProps {
  facilityType: CMSFacilityType
  maxItems?: number
}

const FacilityTypeContent = styled.ul`
  column-gap: ${space('primitives_space_16')};
  margin: 0;
  padding: 0;
  list-style: none;
  padding-left: ${space('primitives_space_8')};
  column-width: ${tokPx('primitives_area_size_280')};
  column-count: 3;
`

const FacilityItem = styled(Typography)`
  color: ${tok('semantics_content_color')};
  position: relative;
  padding-left: ${space('primitives_space_16')};

  &::before {
    content: '•';
    position: absolute;
    left: 0;
    line-height: 1;
    top: 2px;
  }
`

export default function FacilityType({ facilityType, maxItems }: FacilityTypeProps) {
  const facilityTypeNumberOfItems = facilityType?.items?.length ?? 0
  const numberOfItemsToShow = Math.min(maxItems ?? facilityTypeNumberOfItems, facilityTypeNumberOfItems)

  if (!facilityType) {
    return null
  }

  return (
    <FacilityTypeContent>
      {facilityType.items.slice(0, numberOfItemsToShow).map(facility => (
        <FacilityItem $variant="body-m-regular-snug" as="li" key={facility}>
          {facility}
        </FacilityItem>
      ))}
    </FacilityTypeContent>
  )
}
